import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/traffic-red.png'
import _imports_1 from '@/assets/images/traffic-green.png'
import _imports_2 from '@/assets/images/traffic-amber.png'


const _withScopeId = n => (_pushScopeId("data-v-d2a2712c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card bg-light booking-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-header booking-section-header" }, "Send confirmations", -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, "Confirmation to client", -1))
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Send confirmation email to client"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 0,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_14 = {
  key: 1,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, "Correspondance/Feedback to client", -1))
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Send corresponance/feedback email to client"
}
const _hoisted_23 = {
  key: 0,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_24 = {
  key: 1,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, "Confirmation to landlord")
], -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Send email to landlord"
}
const _hoisted_32 = ["title"]
const _hoisted_33 = {
  key: 0,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_34 = {
  key: 1,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, "Confirmation to tenant")
], -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Send email to tenant"
}
const _hoisted_41 = ["title", "disabled"]
const _hoisted_42 = {
  key: 0,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_43 = {
  key: 1,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_44 = {
  key: 2,
  class: "trafficlight",
  src: _imports_2
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, "Send SMS to tenant")
], -1))
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Send SMS"
}
const _hoisted_51 = ["title", "disabled"]
const _hoisted_52 = {
  key: 0,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_53 = {
  key: 1,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_54 = {
  key: 2,
  class: "trafficlight",
  src: _imports_2
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { v4 as uuidv4 } from "uuid";
import { EmailLogs, EmailLog, SMSLogs, Booking, User } from "@/models";
import ProgressButton from "@/components/ProgressButton.vue";
import AlertDialog from "@/components/modals/AlertDialog.vue";
import { useToast } from "vue-toastification"; // Updated import as per guideline 12

import EmailModal from "@/components/modals/EmailModal.vue";
import EmailLogsModal from "@/components/modals/EmailLogsModal.vue";
import SMSModal from "@/components/modals/SMSModal.vue";
import SMSLogsModal from "@/components/modals/SMSLogsModal.vue";
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirmations',
  setup(__props) {

const actProperty: any = inject('actProperty');
const toasted = useToast(); // Using useToast as per guideline 12

const clientconfirmationEmailModal = ref(null);
const clientfeedbackEmailModal = ref(null);
const landlordconfirmationEmailModal = ref(null);
const tenantconfirmationEmailModal = ref(null);
const tenantconfirmationSMSModal = ref(null);
const clientconfirmationEmailLogsModal = ref(null);
const clientfeedbackEmailLogsModal = ref(null);
const landlordconfirmationEmailLogsModal = ref(null);
const tenantconfirmationEmailLogsModal = ref(null);
const tenantconfirmationSMSLogsModal = ref(null);
const alertDialog = ref(null);
const route = useRoute();

const store = useStore();
const emaillogs = computed(() => store.getters['diary/emaillogs']);
const smslogs = computed(() => store.getters['diary/smslogs']);
const booking = computed(() => store.getters['diary/booking']);
const systemproperties = computed(() => store.getters['dictionary/systemproperties']);
const isQCuser = computed(() => store.getters['auth/isQCUser']);
const isBookingManagement = computed(() => store.getters['auth/isBookingManagement']);
const setCurrentEmailLog = (log: EmailLog): void => {
  store.commit('diary/setCurrentEmailLog', log);
};
const removeRequest = (id: string): void => {
  store.commit('app/removeRequest', id);
};
const getEmailLogs = (bookingid: string): Promise<EmailLogs> => {
  return store.dispatch('diary/getEmailLogs', bookingid);
};
const getSMSLogs = (bookingid: string): Promise<SMSLogs> => {
  return store.dispatch('diary/getSMSLogs', bookingid);
};
const generateConfirmationNotePdfAction = (booking: Booking): Promise<any> => {
  return store.dispatch('diary/generateConfirmationNotePdf', booking);
};

const clientconfirmationtitle = computed(() => {
  let title = "Confirmation email";
  if (booking.value && booking.value.customer) {
    if (booking.value.customer.companyName)
      title = "Confirmation email to " + booking.value.customer.companyName;
    if (booking.value.customer.branchName)
      title = title + " - " + booking.value.customer.branchName;
  }
  return title;
});

const landlordconfirmationemailtitle = computed(() => {
  let title = "Confirmation email";
  if (booking.value && booking.value.landlords && booking.value.landlords.length) {
    let landlordnames = booking.value.landlords
      .filter(l => l.llemail)
      .map(l => l.llname);
    if (landlordnames.length)
      title = "Confirmation email to " + landlordnames.join(", ");
  }
  return title;
});

const tenantconfirmationemailtitle = computed(() => {
  let title = "Confirmation email";
  if (booking.value && booking.value.tenants && booking.value.tenants.length) {
    let tenantnames = booking.value.tenants
      .filter(t => t.ttemail)
      .map(t => t.ttname);
    if (tenantnames.length)
      title = "Confirmation email to " + tenantnames.join(", ");
  }
  return title;
});

const tenantconfirmationsmstitle = computed(() => {
  let title = "Confirmation sms";
  if (booking.value && booking.value.tenants && booking.value.tenants.length) {
    let tenantnames = booking.value.tenants
      .filter(t => t.ttmobile)
      .map(t => t.ttname);
    if (tenantnames.length)
      title = "Confirmation sms to " + tenantnames.join(", ");
  }
  return title;
});

const clientconfirmationemaillogstitle = computed(() => {
  let title = "Email logs";
  if (booking.value && booking.value.customer && booking.value.customer.companyName) {
    title = "Email logs to " + booking.value.customer.companyName;
  }
  return title;
});


const reporttype = computed(() => booking.value.jobtype);

const target = computed(() =>
  booking.value.managedtype === 'Managed' ? "Managed Client" : "Non-Managed Client"
);

const showClientConfirmationModal = () => {
  const apptime = booking.value.appointmenttimeForDisplay;
  if (!isBookingManagement.value && !isQCuser.value) {
    if (
      apptime === "No Tenant but Fixed Time" ||
      apptime === "Flexi all day" ||
      apptime === "Flexi AM" ||
      apptime === "Flexi PM"
    ) {
      const modal = alertDialog.value as any;
      if (modal) {
        let message = "";
        if (apptime === "No Tenant but Fixed Time")
          message =
            "Logistics team, you must remove the tenant attending line on the email template";
        else
          message =
            "This booking is flexible! Logistics team, you must remove the 4th bullet point (timing) and the tenant attending line on the email template";
        modal.init("Warning", message, "Yes, I understand");
        modal.show();
      }
    }
  }

  const modal = clientconfirmationEmailModal.value as any;
  modal.init();
  modal.show();
}

const showFeedbackEmailModal = () => {
  const modal = clientfeedbackEmailModal.value as any;
  modal.init();
  modal.show();
}

const showLandlordConfirmationModal = () => {
  const modal = landlordconfirmationEmailModal.value as any;
  modal.init();

  modal.show();
}

const showTenantConfirmationModal = () => {
  const modal = tenantconfirmationEmailModal.value as any;
  modal.init();

  modal.show();
}

const showTenantSMSModal = () => {
  const modal = tenantconfirmationSMSModal.value as any;
  modal.init();

  modal.show();
}

const showClientEmailLogsModal = () => {
  getEmailLogs(booking.value.id);
  if (
    emaillogs.value &&
    emaillogs.value.clientemaillogs &&
    emaillogs.value.clientemaillogs.length > 0
  )
    setCurrentEmailLog(emaillogs.value.clientemaillogs[0]);
  else setCurrentEmailLog(new EmailLog());
  const modal = clientconfirmationEmailLogsModal.value as any;
  modal.show();
}

const showFeedbackEmailLogsModal = () => {
  const modal = clientfeedbackEmailLogsModal.value as any;
  modal.init();

  getEmailLogs(booking.value.id);
  if (
    emaillogs.value &&
    emaillogs.value.feedbackemaillogs &&
    emaillogs.value.feedbackemaillogs.length > 0
  )
    setCurrentEmailLog(emaillogs.value.feedbackemaillogs[0]);
  else setCurrentEmailLog(new EmailLog());
  modal.show();
}

const showLandlordEmailLogsModal = () => {
  const modal = landlordconfirmationEmailLogsModal.value as any;
  getEmailLogs(booking.value.id);
  if (
    emaillogs.value &&
    emaillogs.value.landlordemaillogs &&
    emaillogs.value.landlordemaillogs.length > 0
  )
    setCurrentEmailLog(emaillogs.value.landlordemaillogs[0]);
  else setCurrentEmailLog(new EmailLog());
  modal.show();
}

const showTenantEmailLogsModal = () => {
  const modal = tenantconfirmationEmailLogsModal.value as any;
  getEmailLogs(booking.value.id);
  if (
    emaillogs.value &&
    emaillogs.value.tenantemaillogs &&
    emaillogs.value.tenantemaillogs.length > 0
  )
    setCurrentEmailLog(emaillogs.value.tenantemaillogs[0]);
  else setCurrentEmailLog(new EmailLog());
  modal.show();
}

const showTenantSMSLogsModal = () => {
  const modal = tenantconfirmationSMSLogsModal.value as any;
  getSMSLogs(booking.value.id);
  modal.show();
}

const clienttoaddresses = computed(() => {
  return [booking.value.bookedbyemail];
});

const landlordtoaddresses = computed(() => {
  let toaddresses = [];
  if (booking.value && booking.value.landlords && booking.value.landlords.length) {
    toaddresses = booking.value.landlords
      .filter(l => l.llemail)
      .map(l => l.llemail);
  }
  return [...toaddresses];
});

const tenanttoaddresses = computed(() => {
  let toaddresses = [];
  if (booking.value && booking.value.tenants && booking.value.tenants.length) {
    toaddresses = booking.value.tenants
      .filter(t => t.ttemail)
      .map(t => t.ttemail);
  }
  return [...toaddresses];
});

const bookedbyaddresses = computed(() => {
  let toaddresses = [];
  if (booking.value && booking.value.bookedbyarray && booking.value.bookedbyarray.length && booking.value.customer.policies.onsitefeedbackto.bookedby) {
    toaddresses = booking.value.bookedbyarray
      .filter(b => b.bbemail)
      .map(b => b.bbemail);
  }
  return [...toaddresses];
});

const fromaddress = computed(() => {
  let prop = systemproperties.value?.find(sp => sp.propertykey === 'booking.email.fromaddress');
  return prop?.value;
});
const clientemailbuttontooltip = computed(() => {
  if (!emaillogs.value.clientconfirmationsentdate) {
    return "";
  } else {
    return `Last email was sent on ${actProperty.formatDatetimeForDisplay(
      emaillogs.value.clientconfirmationsentdate
    )}`;
  }
});

const landlordemailbuttontooltip = computed(() => {
  if (!emaillogs.value.landlordconfirmationsentdate) {
    return "";
  } else {
    return `Last email was sent on ${actProperty.formatDatetimeForDisplay(
      emaillogs.value.landlordconfirmationsentdate
    )}`;
  }
});

const tenantemailbuttontooltip = computed(() => {
  if (!emaillogs.value.tenantconfirmationsentdate) {
    return "";
  } else {
    if (!emaillogs.value.tenantconfirmationreceiveddate) {
      return `Last email was sent on ${actProperty.formatDatetimeForDisplay(
        emaillogs.value.tenantconfirmationsentdate
      )}`;
    } else {
      if (emaillogs.value.tenantconfirmationresponse.toLowerCase() === "yes") {
        return `Tenant confirmed on ${actProperty.formatDatetimeForDisplay(
          emaillogs.value.tenantconfirmationreceiveddate
        )}`;
      } else if (emaillogs.value.tenantconfirmationresponse.toLowerCase() === "no") {
        return `Tenant declined on ${actProperty.formatDatetimeForDisplay(
          emaillogs.value.tenantconfirmationreceiveddate
        )}`;
      } else if (emaillogs.value.tenantconfirmationresponse.toLowerCase() === "callback") {
        return `Tenant request callback on ${actProperty.formatDatetimeForDisplay(
          emaillogs.value.tenantconfirmationreceiveddate
        )}`;
      }
      else {
        return "";
      }
    }
  }
});

const tenantsmsbuttontooltip = computed(() => {
  if (!smslogs.value.tenantconfirmationsentdate) {
    return "";
  } else {
    if (!smslogs.value.tenantconfirmationreceiveddate) {
      return `Last sms was sent on ${actProperty.formatDatetimeForDisplay(
        emaillogs.value.tenantconfirmationsentdate
      )}`;
    } else {
      if (smslogs.value.tenantconfirmationresponse.toLowerCase() === "yes") {
        return `Tenant confirmed on ${actProperty.formatDatetimeForDisplay(
          smslogs.value.tenantconfirmationreceiveddate
        )}`;
      } else if (smslogs.value.tenantconfirmationresponse.toLowerCase() === "no") {
        return `Tenant declined on ${actProperty.formatDatetimeForDisplay(
          smslogs.value.tenantconfirmationreceiveddate
        )}`;
      }
      else {
        return "";
      }
    }
  }
});

/**
 * Download Client Confirmation PDF
 *
 * @param {Booking} booking
 * @param {String} requestId
 */
const generateClientConfirmationPdf = (
  booking: Booking,
  requestId: string
): void => {
  generateConfirmationNotePdfAction(booking)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Client confirmation PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
}
const isNewBooking = () => {
  return route.params.id == "new";
}



return (_ctx: any,_cache: any) => {
  return (booking.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: showClientConfirmationModal,
                          title: clientemailbuttontooltip.value
                        }, [
                          (!emaillogs.value.clientconfirmationsentdate)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                            : (_openBlock(), _createElementBlock("img", _hoisted_14)),
                          _createTextVNode(" Email ")
                        ], 8, _hoisted_12),
                        (emaillogs.value.clientemaillogs.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: showClientEmailLogsModal
                            }, _hoisted_16))
                          : _createCommentVNode("", true),
                        _createVNode(ProgressButton, {
                          onDblclick: _cache[0] || (_cache[0] = ($event: any) => (generateClientConfirmationPdf(booking.value, $event))),
                          class: "btn btn-outline-primary",
                          title: "Confirmation"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17,
                            _createTextVNode(" Confirmation ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: showFeedbackEmailModal,
                          style: {"min-height":"33.2px","min-width":"66.8px"}
                        }, [
                          (!emaillogs.value.feedbacksentddate)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                            : (_openBlock(), _createElementBlock("img", _hoisted_24)),
                          _createTextVNode(" Email ")
                        ]),
                        (emaillogs.value.feedbackemaillogs.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: showFeedbackEmailLogsModal,
                              style: {"min-height":"33.2px"}
                            }, _hoisted_26))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (booking.value.managedtype === 'Non-managed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: showLandlordConfirmationModal,
                          title: landlordemailbuttontooltip.value,
                          style: {"min-height":"33.2px"}
                        }, [
                          (!emaillogs.value.landlordconfirmationsentdate)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                            : (_openBlock(), _createElementBlock("img", _hoisted_34)),
                          _createTextVNode(" Email ")
                        ], 8, _hoisted_32),
                        (emaillogs.value.landlordemaillogs.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: showLandlordEmailLogsModal,
                              style: {"min-height":"33.2px"}
                            }, _hoisted_36))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass({ 'col-md-2': booking.value.managedtype === 'Non-managed', 'col-md-3': booking.value.managedtype != 'Non-managed' })
            }, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-secondary",
                      onClick: showTenantConfirmationModal,
                      title: tenantemailbuttontooltip.value,
                      disabled: booking.value.donotcontacttt,
                      style: {"min-height":"33.2px"}
                    }, [
                      (emaillogs.value.tenantconfirmationreceiveddate)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                        : (!emaillogs.value.tenantconfirmationsentdate)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                          : (emaillogs.value.tenantconfirmationsentdate)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                            : _createCommentVNode("", true),
                      _createTextVNode(" Email ")
                    ], 8, _hoisted_41),
                    (emaillogs.value.tenantemaillogs.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: showTenantEmailLogsModal,
                          style: {"min-height":"33.2px"}
                        }, _hoisted_46))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ 'col-md-2': booking.value.managedtype === 'Non-managed', 'col-md-3': booking.value.managedtype != 'Non-managed' })
            }, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-secondary",
                      onClick: showTenantSMSModal,
                      title: tenantsmsbuttontooltip.value,
                      disabled: booking.value.donotcontacttt,
                      style: {"min-height":"33.2px"}
                    }, [
                      (smslogs.value.tenantconfirmationreceiveddate)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_52))
                        : (!smslogs.value.tenantconfirmationsentdate)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_53))
                          : (smslogs.value.tenantconfirmationsentdate)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_54))
                            : _createCommentVNode("", true),
                      _createTextVNode(" SMS ")
                    ], 8, _hoisted_51),
                    (smslogs.value.logs.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: showTenantSMSLogsModal,
                          style: {"min-height":"33.2px"}
                        }, _hoisted_56))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 2)
          ])
        ]),
        _createVNode(EmailModal, {
          id: `clientconfirmation-email-modal`,
          name: `clientconfirmation-email-modal`,
          ref_key: "clientconfirmationEmailModal",
          ref: clientconfirmationEmailModal,
          title: clientconfirmationtitle.value,
          reporttype: reporttype.value,
          target: target.value,
          chronorder: 'Initial confirmation',
          customer: booking.value.customer.id,
          fromaddress: fromaddress.value,
          toaddresses: clienttoaddresses.value,
          label: "Confirmation to client"
        }, null, 8, ["title", "reporttype", "target", "customer", "fromaddress", "toaddresses"]),
        _createVNode(EmailModal, {
          id: `clientfeedback-email-modal`,
          name: `clientfeedback-email-modal`,
          ref_key: "clientfeedbackEmailModal",
          ref: clientfeedbackEmailModal,
          title: "Correspondance/Feedback to client",
          reporttype: reporttype.value,
          target: target.value,
          chronorder: "Correspondance/Feedback to Client",
          customer: booking.value.customer.id,
          fromaddress: fromaddress.value,
          toaddresses: bookedbyaddresses.value,
          label: "Correspondance/Feedback to client"
        }, null, 8, ["reporttype", "target", "customer", "fromaddress", "toaddresses"]),
        _createVNode(EmailModal, {
          id: `landlordconfirmation-email-modal`,
          name: `landlordconfirmation-email-modal`,
          ref_key: "landlordconfirmationEmailModal",
          ref: landlordconfirmationEmailModal,
          title: landlordconfirmationemailtitle.value,
          reporttype: reporttype.value,
          target: 'Landlord',
          chronorder: 'Initial confirmation',
          customer: booking.value.customer.id,
          fromaddress: fromaddress.value,
          toaddresses: landlordtoaddresses.value,
          label: "Confirmation to landlord"
        }, null, 8, ["title", "reporttype", "customer", "fromaddress", "toaddresses"]),
        _createVNode(EmailModal, {
          id: `tenantconfirmation-email-modal`,
          name: `tenantconfirmation-email-modal`,
          ref_key: "tenantconfirmationEmailModal",
          ref: tenantconfirmationEmailModal,
          title: tenantconfirmationemailtitle.value,
          reporttype: reporttype.value,
          target: 'Tenant',
          chronorder: 'Initial confirmation',
          customer: booking.value.customer.id,
          fromaddress: fromaddress.value,
          toaddresses: tenanttoaddresses.value,
          label: "Confirmation to tenant"
        }, null, 8, ["title", "reporttype", "customer", "fromaddress", "toaddresses"]),
        _createVNode(SMSModal, {
          id: `tenantconfirmation-sms-modal`,
          name: `tenantconfirmation-sms-modal`,
          ref_key: "tenantconfirmationSMSModal",
          ref: tenantconfirmationSMSModal,
          title: tenantconfirmationsmstitle.value,
          reporttype: reporttype.value,
          target: 'Tenant',
          chronorder: 'Initial confirmation',
          customer: booking.value.customer.id
        }, null, 8, ["title", "reporttype", "customer"]),
        _createVNode(EmailLogsModal, {
          name: `clientconfirmation-emaillogs-modal`,
          ref_key: "clientconfirmationEmailLogsModal",
          ref: clientconfirmationEmailLogsModal,
          target: 'Client',
          title: clientconfirmationemaillogstitle.value
        }, null, 8, ["title"]),
        _createVNode(EmailLogsModal, {
          name: `clientfeedback-emaillogs-modal`,
          ref_key: "clientfeedbackEmailLogsModal",
          ref: clientfeedbackEmailLogsModal,
          target: target.value,
          chronorder: "Correspondance/Feedback to Client",
          title: "Correspondance/Feedback email logs"
        }, null, 8, ["target"]),
        _createVNode(EmailLogsModal, {
          name: `landlordconfirmation-emaillogs-modal`,
          ref_key: "landlordconfirmationEmailLogsModal",
          ref: landlordconfirmationEmailLogsModal,
          target: 'Landlord',
          title: "Email Logs"
        }, null, 512),
        _createVNode(EmailLogsModal, {
          name: `tenantconfirmation-emaillogs-modal`,
          ref_key: "tenantconfirmationEmailLogsModal",
          ref: tenantconfirmationEmailLogsModal,
          target: 'Tenant',
          title: "Email Logs"
        }, null, 512),
        _createVNode(SMSLogsModal, {
          name: `tenantconfirmation-smslogs-modal`,
          ref_key: "tenantconfirmationSMSLogsModal",
          ref: tenantconfirmationSMSLogsModal,
          title: "SMS Logs"
        }, null, 512),
        _createVNode(AlertDialog, {
          ref_key: "alertDialog",
          ref: alertDialog,
          name: "cnalertdialog"
        }, null, 512)
      ]))
    : _createCommentVNode("", true)
}
}

})